import { useSelector } from "react-redux";
import { Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { ISettingsType } from "common/src/types";
import { AppBlockedScreen } from "views/AppBlocked/Index";
import CircularLoading from "./components/CircularLoading";
import ResponsiveDrawer from './components/ResponsiveDrawer';

function matchUser(permit: any, usertype: any) {
    let permitions = permit ? permit.split(',') : [];
    let permitted = false;
    for (let i = 0; i < permitions.length; i++) {
        permitted = usertype === permitions[i] ? true : false
        if (permitted) break;
    }
    return permitted;
}

function isAppBlocked(settings?: ISettingsType | null) {
    if (!settings?.payment?.dueDateClosingEnd) return false;

    const dueDate = new Date(settings.payment.dueDateClosingEnd);

    if (isNaN(dueDate.getTime())) {
        console.warn('Data inválida:', settings.payment.dueDateClosingEnd);
        return false;
    }

    return dueDate.getTime() <= Date.now();
}

function ProtectedRoute({ permit, children }: any) {
    const auth = useSelector(state => state.auth);
    const [appBlocked, setAppBlocked] = useState(false);
    const [checkedAuth, setCheckedAuth] = useState(false);
    const settings = useSelector(state => state.settingsdata.settings);

    useEffect(() => {
        if (auth.profile && auth.profile.uid) {
            setCheckedAuth(true);
            setAppBlocked(isAppBlocked(settings));
        }
        if (auth.error && auth.error.msg && !auth.profile) {
            setCheckedAuth(true);
        }
    }, [auth.profile, auth.error, settings]);

    if (!checkedAuth) {
        return <CircularLoading />;
    }

    if (!auth.profile?.uid) {
        return <Navigate to="/login" />;
    }

    if (!matchUser(permit, auth.profile.usertype)) {
        return <Navigate to="/login" />;
    }

    if (appBlocked && settings) {
        return <AppBlockedScreen settings={settings} />;
    }

    return <ResponsiveDrawer>{children}</ResponsiveDrawer>;
}

export default ProtectedRoute;